import React, { useEffect } from 'react';
import styles from '../../styles/chart.module.scss';
import { chartTypeToScriptUrlMap } from '../../utils/chart-type-url-map';
import { create } from '@thoughtspot/logger';
import { getNonce } from '@thoughtspot/codec-util';
import { genIframeContent } from './iframe-content';
import { getScriptAbsUrlFromImportFunction } from './helpers';
import { SAME_ORIGIN_IFRAME_COMM_CHANNEL_ID } from './constants';
const logger = create('SameOriginIframeParent');
export const SameOriginIframeComponent = ({ elementId, chartType, chartIframeElRef, onIFrameLoad, onIFrameError, debug, extraData }) => {
    useEffect(() => {
        const loadAndInjectScript = async () => {
            try {
                const iframe = chartIframeElRef.current;
                if (!iframe)
                    return;
                const scriptLoader = chartTypeToScriptUrlMap[chartType];
                if (!scriptLoader) {
                    throw new Error(`No script loader found for chart type: ${chartType}`);
                }
                const scriptAbsUrl = getScriptAbsUrlFromImportFunction(scriptLoader);
                logger.debug('Extracted script absolute URL:', scriptAbsUrl);
                const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
                if (!iframeDoc) {
                    throw new Error('Unable to access iframe document');
                }
                const nonce = getNonce();
                const iframeContent = genIframeContent(scriptAbsUrl, styles.chartIframe, elementId, debug, extraData, nonce);
                iframeDoc.open();
                iframeDoc.write(iframeContent);
                iframeDoc.close();
            }
            catch (error) {
                logger.error('Error loading chart script:', error);
                onIFrameError(error);
            }
        };
        const handleMessage = (event) => {
            const iframe = chartIframeElRef.current;
            if (!iframe || event.source !== iframe.contentWindow) {
                return;
            }
            if (event.origin !== window.location.origin) {
                logger.error('Received message from unexpected origin:', event.origin);
                return;
            }
            const { channel, type, data } = event.data;
            if (channel !== SAME_ORIGIN_IFRAME_COMM_CHANNEL_ID) {
                return;
            }
            logger.debug("New event received: ", type, data);
            switch (type) {
                case 'script-loaded':
                    logger.debug('Chart script loaded in iframe successfully, scriptUrl: ', data.scriptUrl);
                    onIFrameLoad(`#${elementId}`);
                    break;
                case 'error':
                    logger.error('Same-origin iframe error:', data?.errMessage);
                    onIFrameError(data?.errMessage);
                    break;
                default:
                    break;
            }
        };
        window.addEventListener('message', handleMessage);
        loadAndInjectScript();
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [chartType]);
    return (React.createElement("div", { className: styles.chartIframe, id: elementId },
        React.createElement("iframe", { "data-testid": elementId, "aria-label": `Same Origin iframe for hosted charts`, ref: (ref) => {
                chartIframeElRef.current = ref;
            }, style: {
                width: '100%',
                height: '100%',
                border: 'none',
                overflow: 'hidden',
            } })));
};
//# sourceMappingURL=same-origin-iframe.component.js.map